export const DIVISIONE_ASSISTENZA = "Richiesta assistenza tecnica";

export const DIVISIONI = [
    "Autolavaggi Christ Wash Systems (auto, mezzi pesanti, self-service)",
    "Autoriparatore: officina, carrozzeria, gommista, centri revisione",
    "Scaffalature Industriali",
    "Depurazione Acque (ingresso e uscita)",
    "Coperture Esterne Christ Wash Systems",
    "Impianti Industriali",
    DIVISIONE_ASSISTENZA,
    "Altro",
];

export const PRESELECT_EVENT = "ftm:preselect-divisione";

export const preselectDivisione = (divisione) =>
    window.dispatchEvent(new CustomEvent(PRESELECT_EVENT, { detail: divisione }));
